import { VBtn, VTextField } from 'vuetify/lib'
import {mapGetters} from 'vuex'
import VBtnToggle from '@/vuetify_custom/v-btn-toggle'
import VTable from '@/vuetify_custom/v-table/v1'
import VPage from '@/vuetify_custom/v-pagination'
import UserFlowBase from '@/views/components/flow/user_flow_base_jsx_v1'
import CustomerUtil from '@/views/components/customer/libs/util';
import EditModal from './EditModal'
import ExpendComponent from './ExpendComponent'
import { list } from './fields'
import { getsafe } from '@/libs/util.js'
import { handleUserFlow } from '@/views/components/flow/utils.js'
import EditAttachments from '@/views/components/file/edit_attachments_v1';
import CloseShopModal from '@/views/openShopApply/CloseShopModal.jsx'
import { getApplyOpoenShopListApi, getApplyOpenShopDetailApi } from './services'
export default {
    data() {
        return {
            records: [],
            expend_hash: {},
            apply_customer_hash: {},
            getDataLoading: false,
            selectedId: null,
            params: {
                search:'',
                page:1,
                per_page:20,
                total_count: 0,
                search_type: 'pending'
              },
            
        }
    },
    computed: {
      ...mapGetters({
        teams_hash: 'async/root_teams_hash',
      }),
      cur_customer() {
        return this.$store.state.cur_customer;
      },
        tableCFields() {
          const _this = this

            return [
                {
                    expand:true,
                },
                {
                  text: 'uid',
                  align: 'center',
                  value: 'uid',
                  width: 150,
                  render:(val, row) => {
                    let arr = []
                    const user_flow = row.user_flow
                    if (this.params.search_type === 'pending') {
                      const cur_customer = _this.$store.state.cur_customer
                       arr = handleUserFlow({user_flow, current_user_id:cur_customer.id, need_handle:true})
                    }
                    return <div>
                      <span>{val}</span>
                      {arr && !!arr.length && arr.map(item => <Tag color={item.color} type="border" fade={false}> { item.text }</Tag>) || ''}
                    </div>
                  }
                },
                {
                    text: '店铺名称',
                    align: 'center',
                    value: 'shop_name',
                    width: 150
                },
                {
                    text: '店铺负责人',
                    align: 'center',
                    value: 'principal_name',
                    width: 150
                },
                {
                  text: '店铺实际管理人',
                  align: 'center',
                  value: 'manager_name',
                  width: 150
                },
                {
                    text: '团队',
                    align: 'center',
                    value: 'team_id',
                    type: 'team_field',
                    width: 150
                },
                {
                    text: '开店平台',
                    align: 'center',
                    value: 'shop_platform',
                    width: 150
                },
                {
                    text: '申请人',
                    align: 'center',
                    value: 'apply_customer_name',
                    width: 150
                },
                {
                    text: '填表人',
                    align: 'center',
                    value: 'fill_customer_name',
                    width: 150
                },
                {
                    text: '闭店状态',
                    align: 'center',
                    value: 'closing_shop_order',
                    width: 200,
                },
                {
                    text: '状态',
                    align: 'center',
                    value: 'status',
                    width: 200,
                  //   fixed: 'right',
                },
                {
                  text: '操作',
                  b_text: '操作',
                  align: 'center',
                  fixed: 'right',
                  value: 'action_2',
                  type: 'button_s_field',
                  width: 96,
                  z_index:1,
                  callBack:({key}, target) => {
                    switch (key) {
                      case 'edit':
                        this.$refs['modal'].show(target)
                          break;
                      case 'close_shop':
                          this.closeShop(target)
                          break
                      default:
                        break
                    }
                  },
                  buttons:(_, t) => {
                    return [
                      {
                          text: '编辑',
                          key: 'edit',
                          show: this.params.search_type === 'pending'
                      },
                      {
                          text: '闭店申请',
                          key: 'close_shop',
                          // 负责人和管理人以及当前店铺在正常运营的才可以申请闭店
                          show: [t.customer_id, t.manager_id].includes(getsafe(this.cur_customer, 'id')) // && t.status === 1 || true
                      }
                  ].filter(i => i.show)
                }
                  // render: (_, target) => {
                  //   return <VBtn small color="primary" on={{click:() => {
                  //     this.$refs['modal'].show(target)
                  //   }}}>编辑</VBtn>
                  // }
                }
            ]
        },
    },
    created() {
      this.teams_hash
    },
    mounted() {
      this.getList()
    },
    methods: {
      showClose(t) {
        const bfiles = getsafe(t, 'bfiles', [])
        const close_reason = getsafe(t, 'close_reason')
        const transfer_shop = getsafe(t, 'transfer_shop')
        const team_name = getsafe(this.teams_hash, `${t.team_id}.full_name`)
        const principal = getsafe(t,'principal')
        this.$vModal.confirm({
          title: '提示',
          showCancel: false,
          okText: '关闭',
          render:() => {
            return <div>
              <p>
                闭店理由：{close_reason}
              </p>
              <p>
                是否需要转移团队：{transfer_shop ? '是' : '否'}
              </p>
              {!!transfer_shop && <div><p>
                团队：{team_name}
              </p>
              <p>
                店铺负责人：{principal}
              </p></div>}
              {!!bfiles && !!bfiles.length && <EditAttachments 
                  files={bfiles}
                  modelType="ClosingShopOrder"
                  modelId={t.id}
                  close={false}
              />}
            </div>
          }
        })
      },
      stopShopProxy({cancel, target, write_off}) {
        this.$refs.close.edit({target, write_off})
        cancel()
      },
      closeShop(t) {
        this.$vModal.confirm({
          title: '提示',
          showCancel: false,
          okText: '关闭',
          render:(_, {cancel}) => {
           
            return <div>
                <VBtn color="primary" style="margin-right:10px" text on={{
                  click: () => this.stopShopProxy({
                    cancel,
                    target: t,
                    write_off: false,
                  })
                }}>
                  停止运营但不注销
                </VBtn>
                <VBtn color="primary" text on={{
                  click: () => this.stopShopProxy({
                    cancel,
                    target: t,
                    write_off: true,
                  })
                }}>
                  停止运营且注销
                </VBtn>
            </div>
          }
        })
      },
      getList(params = {}) {
        this.getDataLoading = true
        getApplyOpoenShopListApi({...this.params, ...params}).then(({
          results,
          cur_page,
          per_page,
          total_count,
        }) => {
          this.params.page = cur_page
          this.params.per_page = per_page
          this.params.total_count = total_count
          this.records = results
          /* 
          
          
          */
          this.records && this.records.forEach(record => {
            // apply_customer_hash
            if (this.apply_customer_hash[record.customer_id]) {
              record.apply_customer_name = this.apply_customer_hash[record.customer_id].account
              return 
            }
            CustomerUtil.briefInfo(record.customer_id).then(customer => {
              if (!customer) {
               return 
              }
              this.apply_customer_hash[record.customer_id] = customer
             this.$set(record, 'apply_customer_name', customer.account)
           })
            
          });
        
        }).finally(() => {
          this.getDataLoading = false
        })
      }
    },
    render() {
        const _this = this
        return <div>
            <div>
                <div>
                    <VBtnToggle 
                        v-model={_this.params.search_type}
                        list = {list}
                        borderless
                        dense
                        on = {{
                            change(search_type) {
                                _this.records = []
                               _this.$nextTick(() => {
                                _this.getList({search_type, page:1})
                               })
                            }
                        }}
                    />
                    <VTextField
                      v-model={_this.params.search}
                      style={{
                        display: 'inline-block',
                        width: '300px',
                        margin: '0 10px'
                      }}
                      placeholder="请输入关键字"
                      append-icon="mdi-magnify"
                      single-line={true}
                      clearable
                      on={{
                        'click:clear':() => {
                          _this.getList({
                            cur_page:1,
                            search: null,
                          })
                        },
                        'click:append': () => {
                          _this.getList({
                            cur_page:1,
                           
                          })
                        },
                        'keydown': (e) => {
                          if (e && e.code === 'Enter') {
                              _this.getList({
                                  cur_page:1,
                                 
                                })
                          }
                        },
                      }}
                    />
                     <VBtn
                        depressed
                        color="primary"
                        style="margin-left:10px"
                        on = {
                        {
                            click:() => {
                                this.$refs['modal'].show()
                            }
                        }
                        }
                    >
                        新增申请
                    </VBtn>
                    <VTable
                        headers = {_this.tableCFields}
                        desserts = {_this.records}
                        loading={_this.getDataLoading}
                        scopedSlots = {{
                            expand: ({ item }) => {
                        
                              if (!_this.expend_hash[item.id]) {
                                  _this.selectedId = item.id
                                  getApplyOpenShopDetailApi({id:item.id }).then(res => {
                                      _this.expend_hash[item.id] = res
                                  }).finally(() => {
                                      _this.selectedId = null
                                  })
                              }
                            return <ExpendComponent
                                  loading={item.id === _this.selectedId}
                                  item={item}
                                  target={_this.expend_hash[item.id]}
                              />
                          },
                            status: (_, item) => {
                             
                              return <div>
                                {item && !!item.user_flow && <UserFlowBase 
                                  modelC={item}
                                  user_flow={item.user_flow || {}}
                                  show_handles={true}
                              />}
                                {(!item || !item.user_flow) || '-'}
                              </div>
                            },
                            closing_shop_order: (_, item) => {
                              const user_flow = getsafe(item, 'closing_shop_order.user_flow')
                              if (!user_flow) {
                                return <span>-</span>
                              }
                              return <div>
                                 <div>
                                  <div style="text-align:left">
                                    <VBtn color="primary" x-small text on={{click:() => this.showClose(getsafe(item, 'closing_shop_order'))}}>查看详情</VBtn>
                                  </div>
                                  <div>
                                    <UserFlowBase 
                                      modelC={item.closing_shop_order}
                                      user_flow={user_flow || {}}
                                      show_handles={true}
                                    />
                                   
                                  </div>
                                </div>
                              </div>
                            },
                            fill_customer_id:(_) => {
                              return _this.fill_customer_hash && _this.fill_customer_hash[_] && _this.fill_customer_hash[_].account
                            },
                            
                            // closing_shop_order
                        }}
                    />
                </div>
            </div>
            <EditModal
               ref="modal"
               on={{
                 success:(res) => {
                  // 数据更新了，删除之前的缓存数据
                  delete _this.expend_hash[res && res.id]
                  setTimeout(() => {
                    _this.getList({
                      cur_page: 1
                     })
                  }, 500)
                 }
               }}
              />
            <div class="paginate-fix-bottom">
              {!!this.params.total_count && <VPage
                current={this.params.page}
                total={this.params.total_count}
                page-size={this.params.per_page}
                size-arr={[10, 20, 50]}
                on={
                  {
                    changePageSize:(per_page) => {
                      this.getList({
                        page:1,
                        per_page
                      })
                    },
                    pageChange:(page) => {
                      this.getList({
                        page
                      })
                    }
                  }
                }
              />}
            </div>
            <CloseShopModal ref="close" on={{
              success:() => this.getList({
                page:1,
              })
            }}/>
        </div>
    }
} 